import React, { useEffect, useState } from "react";
import {
    apiConstants,
    get,
    postMultipart,
} from "../../common/constants";
import {
    FormProvider,
    RHFFileField,
} from "../../common/hook-form";
import { useForm } from "react-hook-form";
import {
    Box,
    Button,
    Grid,
    Link,
    Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import {
    formatDate,
} from "../../helpers/UtilityHelper";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import MUIModal from "../../common/MUIModal";
import { useSnackbar } from "notistack";
import DownloadSampleFile from "../../common/DownloadSampleFile";
import { getMerchant, getToken } from "../../helpers/ReduxHelpers";
import jwt_decode from "jwt-decode";
import { secondaryTextSx, cellStackSx } from '../orders/list2/cellStyles';
import { filterBarSx, primaryBtnSx } from '../../styles/patterns';
import { FONT, SIZE } from '../../styles/foundation/typography';
import CopyIcon from '../../common/CopyIcon';

const NPRBulkUpload = () => {
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [errorMsg, setErrorMsg] = useState()
    const [dataa, setData] = useState([])
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page1, setPage1] = useState(0);
    const [sizePerPage1, setSizePerPage1] = useState(10);
    const [reload, setReload] = useState(0)
    const [seeOrders, setSeeOrders] = useState(false)
    const [orderData, setOrderData] = useState([])
    const { enqueueSnackbar } = useSnackbar()
    const merchant = getMerchant();
    const { piiAccessAllow } = jwt_decode(getToken());
    const merchantId = merchant.id ? merchant.id : ''
    const methods = useForm({
        defaultValues: {
            nprFile: ''
        }
    });
    const { handleSubmit: handleSubmitBulkUpload, reset: resetForm } = methods;

    const onSubmitBulkUpload = async (data) => {
        setIsUploadingFile(true);
        try {
            let form = new FormData();
            form.append("excelFile", data.nprFile[0])
            form.append("remark", 'NPR Bulk Upload')
            await postMultipart(`${apiConstants.NPR_BULK_UPLOAD_V2}?merchantOid=${merchantId}`, form).then((res) => {
                setIsUploadingFile(false)
                if (res.status === 200 && res.data?.status === 'ERROR') {
                    enqueueSnackbar("File Upload Failed", { variant: "error" });
                    setErrorMsg(res.data?.errorMsg)
                    setIsUploadingFile(false)
                    resetForm()
                } else {
                    enqueueSnackbar("Successfully Uploaded!", { variant: "success" });
                    setIsUploadingFile(false)
                }
            })
            setReload(reload + 1);
            setIsUploadingFile(false)
            resetForm()
        } catch (err) {
            const message = err?.response?.data?.message || err.message;
            enqueueSnackbar(message || "Error uploading file", { variant: "error" });
            setIsUploadingFile(false)
        }
        resetForm({
            nprFile: ''
        })
        setIsUploadingFile(false);
    };

    useEffect(() => {
        get(`${apiConstants.BASE_LOCAL}${apiConstants.GET_BULK_UPLOAD_NPR}?merchantOid=${merchantId}`).then((res) => {
            setData(res?.data?.responseObj)
        })
    }, [reload])

    const columnsOrderModal = [
        {
            field: "awb",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "AWB",
            flex: 0.7,
            minWidth: 120,
            renderCell: (params) => {
                const { row } = params;
                return row?.data?.awbNumber ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>{row.data.awbNumber}<CopyIcon text={row.data.awbNumber} /></span> : ''
            },
        },
        {
            field: "action",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "NPR Action",
            flex: 0.7,
            minWidth: 120,
            renderCell: (params) => {
                const { row } = params;
                return row?.data?.action
            },
        },
        {
            field: "remark",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Remark",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => {
                const { row } = params;
                return row?.response?.remark
            },
        },
        {
            field: "actionBy",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Action User",
            flex: 1,
            minWidth: 130,
            renderCell: (params) => {
                const { row } = params;
                return row?.data?.actionedBy
            },
        },
    ];

    const columns = [
        {
            field: 'id', headerAlign: "center", hideSortIcons: true, headerName: 'Id', flex: 1.2, minWidth: 100,
        },
        ...(piiAccessAllow ? [{
            field: 'file', headerAlign: "center", hideSortIcons: true, headerName: 'Uploaded File', flex: 1,
            align: 'center', minWidth: 120, renderCell: (params) => {
                const { row } = params;
                return (
                    <Link href={row?.s3RefToFile?.signedLink} target="_blank" rel='noreferrer' style={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: 'black', textDecoration: 'underline', cursor: 'pointer' }}>File</Link>
                )
            },
        }] : []),
        {
            field: 'fileProgress', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Status', flex: 1, minWidth: 100,
        },
        {
            field: 'createdAt', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Upload Date', width: 150, minWidth: 150, renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography sx={secondaryTextSx}>
                        {formatDate(row?.createdAt)}
                    </Typography>
                )
            },
        },
        {
            field: 'totalRecords', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Upload Status', flex: 1.2, minWidth: 180, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>
                            Total Shipments: {row?.executionStatus?.totalTasks}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            Failed Shipments: {row?.executionStatus?.failed}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            Successful Shipments: {row?.executionStatus?.success}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'successOrders', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Successful Orders', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                if (row?.executionStatus?.success > 0) {
                    return (
                        <Box sx={cellStackSx}>
                            <Button
                                sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}
                                onClick={() => {
                                    const flattenedArray = [].concat(...row?.taskListBatch);
                                    let k = flattenedArray?.filter((item) => item?.status === "SUCCESS");
                                    setOrderData(k);
                                    setSeeOrders(true);
                                }}
                            >
                                View Details
                            </Button>
                            <Typography sx={secondaryTextSx}>
                                Successful Shipments : {row?.executionStatus?.success}
                            </Typography>
                        </Box>
                    )
                }
                else {
                    return ("-")
                }
            },
        },
        {
            field: 'failedOrders', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Failed Orders', flex: 1, minWidth: 150, renderCell: (params) => {
                const { row } = params;
                if (row?.executionStatus?.failed > 0) {
                    return (
                        <Box sx={cellStackSx}>
                            <Button
                                sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}
                                onClick={() => {
                                    const flattenedArray = [].concat(...row?.taskListBatch);
                                    let k = flattenedArray?.filter((item) => item?.status !== "SUCCESS");
                                    setOrderData(k);
                                    setSeeOrders(true);
                                }}
                            >
                                View Details
                            </Button>
                            <Typography sx={secondaryTextSx}>
                                Failed Shipments : {row?.executionStatus?.failed}
                            </Typography>
                        </Box>
                    )
                }
                else {
                    return ("-")
                }
            },
        },
        {
            field: 's3LinkExcelResponse', headerAlign: "center", hideSortIcons: true, headerName: 'Download Response', flex: 1,
            align: 'center', minWidth: 150, renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        {row?.s3LinkExcelResponse && row?.s3LinkExcelResponse.length > 0 ?
                            <Link href={row?.s3LinkExcelResponse} target="_blank" rel='noreferrer' style={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: 'black', textDecoration: 'underline', cursor: 'pointer' }}>File</Link>
                            : '-'
                        }
                    </>
                )
            },
        },
    ]

    return (
        <>
            <Box sx={filterBarSx}>
                <FormProvider
                    methods={methods}
                    onSubmit={handleSubmitBulkUpload(onSubmitBulkUpload)}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <RHFFileField required={true} fileType={['xlsx']} name="nprFile" label="Click here to upload. Maximum 500 NPR actions can be uploaded in one file." accept={["csv"]} />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <LoadingButton
                                startIcon={<FileUploadIcon />}
                                type="submit"
                                loading={isUploadingFile}
                                variant="contained"
                                size="small"
                                sx={primaryBtnSx}
                            >
                                Upload
                            </LoadingButton>
                            <DownloadSampleFile fileName={"NPR_BULK_ACTION_V2"} label='SAMPLE' excel={'excel'} />

                        </Grid>
                        {errorMsg && errorMsg !== '' && (
                            <Grid item xs={12} sm={12} sx={{ justifyContent: 'right' }}>
                                <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: '#d32f2f' }}>{"0 records succeeded. Error details : " + errorMsg + " . Please make changes to the file and reupload. "}</Typography>

                            </Grid>
                        )}
                    </Grid>
                </FormProvider>
            </Box>

            <ProzoDataGrid
                columns={columns}
                rows={dataa.length > 0 ? dataa : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                filterMode={"server"}
                paginationMode={'client'}
                rowCount={dataa?.length}
                getRowId={(row) => row.id}
            />

            <MUIModal
                open={seeOrders}
                title="AWB Details"
                maxWidth={"lg"}
                handleClose={() => setSeeOrders(false)}
            >
                <ProzoDataGrid
                    sizePerPage={sizePerPage1}
                    setSizePerPage={setSizePerPage1}
                    page={page1}
                    setPage={setPage1}
                    rowCount={orderData?.length}
                    columns={columnsOrderModal}
                    rows={orderData}
                    paginationMode={'client'}
                    pagination={true}
                    hideFooterPagination={false}
                    getRowId={(row) => Math.random()}
                />
            </MUIModal>
        </>

    );
};
export default NPRBulkUpload;
